var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import classNames from 'classnames';
import PasswordUpdate from './PasswordUpdate';
import PasswordLogin from './PasswordLogin';
import { validateLoginForm } from '../../../validation';
import s from '../../../Login.module.scss';
const Password = ({ shouldUpdatePassword, onSubmit, onBack }) => {
    const [formData, setFormData] = useState({ email: '', password: '', newPassword: '' });
    const [checkEmail, setCheckEmail] = useState(false);
    const [loading, setLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const disabled = loading ||
        Object.keys(formData)
            // Ignore newPassword if shouldUpdatePassword is not true
            .filter((key) => shouldUpdatePassword || key !== 'newPassword')
            .some((key) => !formData[key]);
    const onSubmitHandler = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        e.preventDefault();
        setValidationErrors({});
        // Validate form data
        const validation = validateLoginForm(formData.email, formData.password);
        if (!validation.isValid) {
            setValidationErrors(validation.errors);
            return;
        }
        try {
            setLoading(true);
            yield onSubmit(formData.email, formData.password, shouldUpdatePassword ? formData.newPassword : undefined);
        }
        catch (e) {
            console.error(((_a = e.error) === null || _a === void 0 ? void 0 : _a.message) || e);
        }
        finally {
            setLoading(false);
        }
    });
    return (React.createElement("div", { className: s.pageWrapper },
        shouldUpdatePassword ? (React.createElement(PasswordUpdate, { onSubmitHandler: onSubmitHandler, formData: formData, setFormData: setFormData, loading: loading, disabled: disabled, errors: { password: validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.password, newPassword: validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.newPassword } })) : (React.createElement(PasswordLogin, { onSubmitHandler: onSubmitHandler, formData: formData, setFormData: setFormData, loading: loading, disabled: disabled, errors: { email: validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.email, password: validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.password }, onBack: onBack })),
        checkEmail ? (React.createElement("p", { className: classNames(s.notificationText, s.loginEmailCheck) },
            React.createElement(Trans, { i18nKey: "checkEmail" }))) : null));
};
export default Password;
